// extracted by css-extract-rspack-plugin
export default {"number":"Vj9izk3OJXwElm4a"};